import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { WixConnect } from 'shared/utils/wix-connect';

import TooltipPopout from 'shared/components/tooltip/tooltip-popout';
import { MobileModal } from 'shared/components/modal/modal';
import BIUnhandledErrorLogger from 'shared/bi/bi-unhandled-error-logger';
import MobileSpinnerOverlay from 'widget/components/mobile-spinner-overlay/mobile-spinner-overlay';
import { selectVideo } from 'widget/redux/client/actions/select-video';
import { getVideosGroupedByIds } from 'shared/selectors/videos';

import BiHandler from 'shared/bi/bi-handler';
import UpdateChannelPublishedState from 'widget/data-components/update-channel-published-state';
import UpdateWidgetSize from 'widget/data-components/update-widget-size';
import ChannelLoader from 'widget/data-components/channel';
import PaymentInfoLoader from 'widget/data-components/payment-info';
import ChannelVideoLoader from 'widget/data-components/channel-video';
import LazyChannelVideosLoader, { MOBILE_WIDGET_DATA_KEY } from 'widget/data-components/lazy-channel-videos';
import CurrentSiteUser from 'widget/data-components/current-site-user';
import ReloadChannelPaymentDataOnPayment from 'widget/data-components/reload-channel-payment-data-on-payment';
import ClearVideoUrlsCacheOnPayment from 'widget/data-components/clear-video-urls-cache-on-payment';
import PaymentEventProxy from 'shared/components/payment-events/proxy';
import PaymentsBiHandler from 'widget/components/payments/bi-handler';

import {
  getAllSettings,
  getChannelLayout,
  getVideosInRowCount,
  getEditMode,
} from 'shared/selectors/app-settings';

import { getVideoIdFromUrl } from 'widget/selectors/query-params.js';

import WidgetHeightByContentSync from './widget-height-by-content-sync';

import 'shared/styles/core.styl';
import styles from './mobile.styl';


@connect(state => ({
    appSettings: getAllSettings(state),
    videosInRow: getVideosInRowCount(state),
    currentChannelId: state.currentChannelId,
    layout: getChannelLayout(state),
    editMode: getEditMode(state),
    selectedVideoId: state.selectedVideoId,
    videoIdFromUrl: getVideoIdFromUrl(state),
    videos: getVideosGroupedByIds(state),
  }),
  {
    selectVideo,
  }
)
@WixConnect(styles)
export default class MobileLayout extends React.Component {

  static propTypes = {
    children: PropTypes.element,
    currentChannelId: PropTypes.string,
    selectedVideoId: PropTypes.string,
    videoIdFromUrl: PropTypes.string,
    appSettings: PropTypes.object,
    layout: PropTypes.number,
    editMode: PropTypes.string,
    videosInRow: PropTypes.number,
    selectVideo: PropTypes.func,
    videos: PropTypes.object,
  };

  componentWillUpdate(nextProps) {
    const { videoIdFromUrl, selectedVideoId, videos } = nextProps;

    if (videoIdFromUrl && !selectedVideoId && !_.isEmpty(videos[videoIdFromUrl])) {
      this.props.selectVideo(videoIdFromUrl);
    }
  }

  get content() {
    const { children, appSettings, currentChannelId, videoIdFromUrl, videosInRow } = this.props;

    if (!appSettings || !currentChannelId) {
      return (
        <MobileSpinnerOverlay />
      );
    }

    return (
      <WidgetHeightByContentSync>
        <ChannelLoader channelId={currentChannelId}>
          <LazyChannelVideosLoader channelId={currentChannelId}
                                   as={MOBILE_WIDGET_DATA_KEY}
                                   numberToLoadMore={videosInRow * 3}>
            <ChannelVideoLoader channelId={currentChannelId}
                                videoId={videoIdFromUrl}>
              <CurrentSiteUser>
                <PaymentInfoLoader channelId={currentChannelId}>
                  {children}
                  <PaymentEventProxy />
                  <ReloadChannelPaymentDataOnPayment />
                  <ClearVideoUrlsCacheOnPayment />
                </PaymentInfoLoader>
              </CurrentSiteUser>
            </ChannelVideoLoader>
          </LazyChannelVideosLoader>
        </ChannelLoader>
      </WidgetHeightByContentSync>
    );
  }

  render() {
    const { currentChannelId, appSettings, layout, editMode } = this.props;

    return (
      <div styleName="container"
           data-layout={layout}
           data-view-mode={editMode}>
        <BiHandler />
        <BIUnhandledErrorLogger />
        <PaymentsBiHandler />
        <UpdateChannelPublishedState channelId={currentChannelId} />
        <UpdateWidgetSize />
        {this.content}
        <MobileModal settings={appSettings} />
        <TooltipPopout />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/layouts/mobile/mobile.js